import { Pipe, PipeTransform } from '@angular/core';
import { MonitoredTrain } from '@/app/features/monitoring/models/monitored-train';
import { TrainTypeConfiguration } from '../models/monitored-train';

@Pipe({
  name: 'trainCanvas'
})
export class TrainCanvasPipe implements PipeTransform {

  transform(train: MonitoredTrain, currentTrainTypeConfiguration: TrainTypeConfiguration): any {
    return train && {
      train: train.structure,
      trainConsists: train.trainConsists,
      trainConsistView: train.trainConsistView,
      dynamicConsist: currentTrainTypeConfiguration?.dynamicConsist
    };
  }

}
